<header class="product-header" [ngClass]="{'dark-mode': isDarkMode}">
  <div class="product-info">
    <div class="product-icon" (click)="onToggleSidebar()">
      <!-- Always show hamburger menu when sidebar is closed (visible in both desktop and mobile) -->
      @if (!isSidebarOpen) {
        <i class="pi pi-bars" style="font-size: 1.8em; margin-bottom: 5px;cursor: pointer;"></i>
      }
      @if (isSidebarOpen) {
        <i class="pi pi-times mobile-only" style="font-size: 1.8em; margin-bottom: 5px;cursor: pointer;"></i>
      }
    </div>
    <div class="product-details">
      <img loading="lazy" src="assets/images/CNP Symbol.svg" alt="Company Logo" class="logo-image" />
    </div>
    <div >
      <span class="product-name">{{ productName }}</span>
    </div>

  </div>
  <div class="header-actions">
    @if (isSearchVisible) {
      <form class="search-form" (ngSubmit)="onSearch($event)">
        <div class="search-input-container">
          <input type="text" id="searchInput" class="search-input" placeholder="Search" [(ngModel)]="searchValue" name="search" aria-label="Search">
          <i class="pi pi-times" (click)="clearSearch()"></i>
        </div>
      </form>
    }
    @if (isSearchVisible) {
      <i class="pi pi-search" style="font-size: 1.5em; margin-right: 10px;cursor: pointer;" (click)="toggleSearch()"></i>
    }
    @if (isNotificationVisible) {
      <p-badge [value]="notificationCount.toString()" severity="danger">
        <i class="pi pi-bell" style="font-size: 1.5em;cursor: pointer;"></i>
      </p-badge>
    }

    <!-- Change the icon depending on dark mode state -->
    @if (isThemeVisible) {
      <i [ngClass]="isDarkMode ? 'pi pi-sun' : 'pi pi-moon'" style="font-size: 1.5em; margin-right:5px; cursor: pointer;" (click)="toggleDarkMode()"></i>
    }
    @if (profile !== undefined) {
      <p-avatar label="{{ (profile.givenName?.charAt(0) || '') + (profile.surname?.charAt(0) || '') }}" [style]=""
        styleClass="p-mr-2"
        shape="circle"
        size="large"
        title="{{ profile.displayName || 'User' }}" >
      </p-avatar>
    }
  </div>
</header>
